import { callEndpoint } from '../backend';
import { getStore } from '../store';
import {
  ROUTE_WEATHER_MOST_RECENT_POSITION,
  ROUTE_AUTHENTICATION_EMAIL_VALIDATION_OF_CLIENT_TOKEN,
} from '../route/route-names';
import {
  getUrlForRouteWithGivenParameters,
  transitionToNextRoute,
} from '../route/route-navigation';

export const getWarningDetails = async (id) => {
  const warning = await callEndpoint(callEndpoint.endpoints.getWarning, {
    ':id': id,
  });

  return warning;
};

export const getWarnings = async (latitude, longitude) => {
  const { warnings } = await callEndpoint(
    callEndpoint.endpoints.getWarnings,
    {},
    {
      latitude,
      longitude,
    },
  );
  return warnings;
};

// eslint-disable-next-line import/prefer-default-export
export const initialize = async () => {
  const { weatherConfig } = getStore().getState().appControls.memberSettings;

  const [authUrl] = getUrlForRouteWithGivenParameters(
    ROUTE_AUTHENTICATION_EMAIL_VALIDATION_OF_CLIENT_TOKEN,
  );

  // Check for weather on startup
  if (
    weatherConfig?.weatherOnStartup &&
    !window.location.href.includes(authUrl)
  ) {
    // if weather in URL, then it's a direct link and will already load weather
    if (!window.location.href.includes('weather')) {
      transitionToNextRoute(ROUTE_WEATHER_MOST_RECENT_POSITION);
    }
  }
};
